<template>
    <table :class="'gradient-table w-full' + ' ' + (darkMode ? 'dark' : '')">
        <thead class="">
            <tr>
                <th class="md:min-w-[50px]">&nbsp;</th>
                <th
                    v-for="(header, index) in tableHeaders"
                    :class="'p-3 px-1 text-left text-left text-[16px] font-semibold md:px-3'"
                >
                    {{ header }}
                </th>
                <th class="md:min-w-[50px]">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="tableValues in tableRows"
                class="gradient-table-row group text-[20px]"
            >
                <td></td>
                <td
                    v-for="(tableCell, index) in tableValues"
                    :class="
                        'p-3 px-1 text-left md:px-3' +
                        ' ' +
                        tableRowClass +
                        ' ' +
                        tableCellCss[index]
                    "
                >
                    {{ tableCell }}
                </td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: "gradient-table",
    props: {
        tableHeaders: {
            type: Array,
            default: [],
        },
        tableRows: {
            type: Array,
            default: [],
        },
        tableCellCss: {
            type: Array,
            default: [],
        },
        tableRowClass: {
            type: String,
            default: "",
        },
        darkMode: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style scoped>
.gradient-table {
    .gradient-table-row {
        background-image: url(/assets/art/gradient_table_line.png);
        background-position: top center;
        background-repeat: no-repeat;
        background-size: 100% 1px;
        padding-top: 1px;
    }
}

.gradient-table.dark {
    .gradient-table-row {
        background-image: url(/assets/art/gradient_table_line_on_dark.png);
    }
}
</style>
